import React from 'react';
import { Box, Typography, keyframes, LinearProgress, useTheme, alpha } from '@mui/material';

const flyAndPulse = keyframes`
  0% {
    transform: translateY(0) scale(1);
    opacity: 0.5;
  }
  25% {
    transform: translateY(-15px) scale(1.1);
    opacity: 0.8;
  }
  50% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  75% {
    transform: translateY(15px) scale(0.95);
    opacity: 0.8;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 0.5;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const LoadingScreen = () => {
  const theme = useTheme();
  const brandColor = theme.palette.brand?.main || '#9333EA';
  const brandDark = theme.palette.brand?.dark || '#7C3AED';

  return (
    <Box
      sx={{
        height: '100dvh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        gap: 4,
      }}
    >
      <Box
        sx={{
          width: { xs: '280px', sm: '360px', md: '420px' },
          maxWidth: '90vw',
          animation: `${fadeIn} 1s ease-out`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img
          src="/ai-flock-logo.png"
          alt="AIFlock"
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'contain'
          }}
          onError={(e) => {
            // Fallback: load icon + text separately
            e.target.outerHTML = `
              <div style="display: flex; align-items: center; gap: 16px;">
                <img src="/icon-ai-flock.png" alt="AIFlock" style="width: 80px; height: 80px; object-fit: contain;" />
                <span style="color: ${brandColor}; font-size: 3rem; font-weight: bold; letter-spacing: 0.2em; font-family: 'Raleway', sans-serif;">AIFLOCK</span>
              </div>
            `;
          }}
        />
      </Box>

      <Typography
        variant="h6"
        sx={{
          color: brandColor,
          opacity: 0.8,
          fontWeight: 500,
          letterSpacing: '0.1em',
          animation: `${fadeIn} 1s ease-out`,
          mt: 2,
          fontFamily: "'Raleway', 'Inter', sans-serif",
        }}
      >
        Intelligent Automation
      </Typography>

      {/* Loading indicator and status */}
      <Box
        sx={{
          mt: 6,
          width: '300px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            opacity: 0.7,
            fontWeight: 500,
            animation: `${fadeIn} 1.5s ease-out`,
            textAlign: 'center'
          }}
        >
          Inicializando aplicación...
        </Typography>
        
        <LinearProgress
          sx={{
            width: '100%',
            height: 4,
            borderRadius: 2,
            bgcolor: alpha(brandColor, 0.1),
            animation: `${fadeIn} 2s ease-out`,
            '& .MuiLinearProgress-bar': {
              borderRadius: 2,
              background: `linear-gradient(90deg, ${brandColor} 0%, ${brandDark} 100%)`
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default LoadingScreen; 